// Mock data for BotsPay.me (light-reversed clone of MyBotsPay.me)
// This is the "botspay.me" variant used by the executive team & G-Club members.
// The key difference vs mybotspay.me: Step 01 contains a DIRECT registration link.

export const LINKS = {
  liveClassZoom: "https://us06web.zoom.us/j/2480049812",
  community: "https://shyftcoalition.com/?autojoin=1",
  performance: "http://eazybot.info/performance",
  support: "support@shyftcoalition.com",
  // Direct EazyBot registration referral link (botspay.me exclusive)
  eazybotRegister: "https://linkly.link/24MCK",
  voucher: "https://shyftcoalition.com/?autojoin=1",
  vimeoId: "1060363287",
  flourishUSDT: "https://flo.uri.sh/visualisation/12672384/embed",
  flourishPercent: "https://flo.uri.sh/visualisation/12525317/embed",
  flourishTrades: "https://flo.uri.sh/visualisation/12675780/embed",
  shareUrl: "https://botspay.me",
  sponsor: "https://shyftcoalition.com/",
  setupEmail: "mailto:eazybot@shyftasap.com?subject=EazyBot%20Setup%20Assistance",
};

export const HERO = {
  eyebrow: "AUTOPILOT YOUR INCOME",
  titleTop: "EVERYONE Needs",
  titleBottom: "Trading Bots",
  paragraphs: [
    "Trading bots are software programs designed to read different financial markets and execute trades. They were developed by banks decades ago to replace their professional traders, allowing them to drastically minimize losses and create predictable profits.",
    "Until recently, these ‘Digital Employees’ were reserved for the financial industry, accredited investors and a select group of well informed people. Thanks to the emergence of blockchain technology, that’s no longer the case.",
  ],
};

export const INTRODUCING = {
  eyebrow: "DIGITAL EMPLOYEES",
  heading: "Introducing EazyBot",
  paragraphs: [
    "EazyBot is a company that allows anyone to lease crypto trading bots that are continuously refined to earn consistent income for its users.",
    "This gives you and your family access to extra streams of easy income, because your trading bots do all the work but you get to keep the profits.",
  ],
};

export const FEATURES = {
  eyebrow: "WHY EAZYBOT",
  heading: "Key Features",
  description: "These key features separate EazyBot from any competitors.",
  items: [
    { icon: "dollar", title: "No Upfront Costs", body: "The company allows everyone to start using EazyBot for FREE, then upgrade to a paid subscription once you're familiar with EazyBot's online portal and earning potential." },
    { icon: "clock", title: "Trades 24/7/365", body: "The company's proven autopilot settings allow your digital employees to work around the clock, earning consistent income for you and your family." },
    { icon: "shield", title: "Non-Custodial", body: "You don't give your money to EazyBot and wait for them to pay you back. Your funds stay in your own crypto wallet that only YOU control, and you remain in control of your funds while EazyBot executes trades." },
    { icon: "mouse", title: "Easy to Use", body: "Your digital employees handle the labor that earns your income. Your job is to hire them and put them to work." },
    { icon: "trending", title: "Compounds Your Profits", body: "EazyBot automatically reinvests the profits from your trades, allowing your trading balance to compound over time." },
  ],
};

export const PERFORMANCE = {
  eyebrow: "PROVEN PERFORMANCE",
  heading: "100% Principal Increase in 18 Months",
  statement: "Realistic Expectations, NOT Impossible Promises!",
  intro: "EazyBot has years of documented performance data that proves its consistent profitability. These charts are an example of one corporate account, click the link below them to see more results.",
  tradesClosed: 259,
  disclaimer:
    "Past results are not a guarantee of future performance.\nNote: this account is not paying SSF.",
  // Mock chart data for the "Profit · Per Coin · %" bar chart
  coins: [
    { coin: "SOL/USDT", value: 13.75 },
    { coin: "MANA/USDT", value: 13.15 },
    { coin: "SAND/USDT", value: 11.9 },
    { coin: "AVAX/USDT", value: 9.22 },
    { coin: "CRV/USDT", value: 8.8 },
    { coin: "FIL/USDT", value: 8.42 },
    { coin: "SHIB/USDT", value: 7.2 },
    { coin: "AAVE/USDT", value: 6.98 },
    { coin: "MATIC/USDT", value: 6.55 },
    { coin: "DOGE/USDT", value: 5.17 },
    { coin: "ALGO/USDT", value: 5.48 },
    { coin: "CHZ/USDT", value: 5.52 },
    { coin: "LTC/USDT", value: 4.03 },
    { coin: "LINK/USDT", value: 3.7 },
    { coin: "XRP/USDT", value: 1.9 },
  ],
};

export const VIDEO = {
  eyebrow: "The Overview",
  heading: "See how EazyBot works",
  sub: "A short walkthrough of the key features and how EazyBot operates.",
};

export const CTA = {
  liveEyebrow: "LIVE EAZYBOT CLASSES",
  liveHeading: "How EazyBot Works",
  liveDescription: "Attend a live EazyBot class to learn more details and get your questions answered.",
  eyebrow: "GET STARTED TODAY",
  heading: "30 Day Free Trial",
  description: "Get started today with EazyBot's 30 Day Free Trial! Our step-by-step setup videos will walk you through the process. If you need extra assistance, our Setup Team is here to help.",
  timezones: [
    { id: "et", label: "8pm ET" },
    { id: "ct", label: "7pm CT" },
    { id: "mt", label: "6pm MT" },
    { id: "pt", label: "5pm PT" },
  ],
};

// Get Started modal steps (botspay.me version — Step 01 has the direct link)
export const GET_STARTED = {
  eyebrow: "Get Started",
  heading: "Getting Started is Easy",
  sub: "Three steps to put your own digital employees to work.",
  steps: [
    {
      no: "01",
      icon: "bot",
      title: "Create Your EazyBot Account",
      pill: { label: "Get Registered", href: "https://linkly.link/24MCK" },
    },
    {
      no: "02",
      icon: "wallet",
      title: "Set Up Your Kraken & Coinbase Accounts",
      body: "Find the Kraken (not Kraken Pro) and Coinbase apps in your phone’s app store. Download the apps and follow the steps to set up new accounts.",
      body2: "If you already have Kraken & Coinbase accounts, go to the next step.",
    },
    {
      no: "03",
      icon: "ticket",
      title: "Get Your EazyBot Voucher",
      body: "Claim your voucher to schedule your one-on-one setup session.",
      cta: { label: "Voucher", href: "https://shyftcoalition.com/?autojoin=1" },
    },
  ],
};

export const FOOTER = {
  sponsor: "SHYFT Coalition",
  support: "support@shyftcoalition.com",
  copyright: "© 2026 SHYFT Coalition™ All Rights Reserved.",
};

// =====================================================================
// Dedicated "Get Started" PAGE (route: /get-started)
// Videos are YouTube embeds. Leave youtubeId null to show a "Coming Soon"
// placeholder. Drop a cover image in /public and set `thumbnail` to swap.
// =====================================================================
export const GET_STARTED_PAGE = {
  eyebrow: "EAZYBOT SETUP GUIDE",
  heading: "Getting Started is Easy",
  sub: "Our Step-by-Step Video Setup Guide makes it easy for you to put your digital employees to work. If you need assistance, send us an email and we'll schedule a one-on-one Zoom with you and a member of our Setup Team.",
  email: { label: "Email us: EazyBot@SHYFTASAP.com", href: "mailto:eazybot@shyftasap.com?subject=EazyBot%20Setup%20Assistance" },
  steps: [
    {
      no: "01",
      icon: "bot",
      title: "Create Your EazyBot Account",
      pill: { label: "Get Registered", href: "https://linkly.link/24MCK" },
      videos: [],
    },
    {
      no: "02",
      icon: "wallet",
      title: "Setup Your Coinbase or Kraken Account",
      body: "Find the Coinbase or Kraken App in your phone's app store, then download it and follow the steps to setup a new account. We recommend creating your accounts on your phone because you'll need your camera to complete the account verification process. Once your account is set up, you can log in from your computer.",
      body2: "*If you already have a Coinbase or Kraken account, go to the next step.",
      body2Italic: true,
      noteFirst: true,
      videos: [],
    },
    {
      no: "03",
      icon: "banknote",
      title: "Add Funds to Your Coinbase or Kraken Account",
      body: "EazyBot is a non-custodial company so you don't send them your money. Your Coinbase and/or Kraken accounts are where your trading money resides.",
      body2: "*If you already have funds in your Coinbase or Kraken account, go to the next step.",
      body2Italic: true,
      noteFirst: true,
      videos: [
        { title: "Add Funds — Coinbase", youtubeId: "_LD4TM-qPh4", thumbnail: "/covers/coinbase-cover.png" },
        { title: "Add Funds — Kraken", youtubeId: "q_KitYjkth4", thumbnail: "/covers/kraken-cover.jpeg" },
      ],
    },
    {
      no: "04",
      icon: "link",
      title: "Connecting Your Accounts via API",
      body: "The API connection is how your EazyBot account communicates with your Coinbase or Kraken account. For security purposes, Coinbase and Kraken don't allow their customers to manage their API connections through cellular networks. You must use a computer.",
      videos: [
        { title: "API Connection — Coinbase", youtubeId: "qxr6mIbTAlg", thumbnail: "/covers/coinbase-cover.png" },
        { title: "API Connection — Kraken", youtubeId: "e1d3U84JA5E", thumbnail: "/covers/kraken-cover.jpeg" },
      ],
    },
    {
      no: "05",
      icon: "rocket",
      title: "Start Your EazyBots",
      body: "Your EazyBots are engineered to run on autopilot, but we encourage you to join our online community and attend a few Zoom trainings to learn the details about how your digital employees earn income for you.",
      videos: [
        { title: "Starting Your EazyBots", youtubeId: null, thumbnail: "/covers/eazybot-cover.png" },
      ],
    },
    {
      no: "06",
      icon: "coins",
      title: "Add Funds to Your EazyBot Account",
      body: "These funds will be used to upgrade your EazyBot account to a paid subscription and pay for your initial SSF (Software Service Fees).",
      videos: [
        { title: "Adding Funds from Coinbase", youtubeId: "sdS7-J9VgfM", thumbnail: "/covers/step6-coinbase.png" },
        { title: "Adding Funds from Kraken", youtubeId: "4qw7jVc-CB0", thumbnail: "/covers/step6-kraken.png" },
        { title: "Adding Funds from Uphold", youtubeId: "VParMKzeEwg", thumbnail: "/covers/step6-uphold.png" },
        { title: "Adding Funds from PayPal", youtubeId: null, thumbnail: "/covers/step6-paypal.png" },
      ],
    },
    {
      no: "07",
      icon: "upgrade",
      title: "Upgrade Your Subscription",
      body: "EazyBot gives you 30 days of free use to personally validate it's earning potential. When your free trial is over you'll keep access to your online portal, but you must upgrade to a paid subscription to continue earning income from your digital employees.",
      body2: "*Subscriptions start at $100/yr with no monthly payments.",
      body2Italic: true,
      videos: [
        { title: "Upgrade Your Subscription", youtubeId: null, thumbnail: "/covers/eazybot-cover.png" },
      ],
    },
  ],
  needHelp: {
    eyebrow: "GET EDUCATED",
    heading: "Join the SHYFT Coalition",
    body: "Our FREE Online Educational Community has all the support you need to maximize your EazyBot experience.",
    cta: { label: "Join Our Community", href: "https://shyftcoalition.com/?autojoin=1" },
  },
};
